import { Button } from 'ui-components/components/button';
import { Text, TextType } from 'ui-components/components/text';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { messages } from '../automation-tools/messages';

import style from './tool-action-button.module.less';

import type React from 'react';

type ToolActionButtonProps = {
  isSetup: boolean;
  onClick: () => void;
};

export const ToolActionButton = ({ isSetup, onClick }: ToolActionButtonProps) => (
  <Button className={style['tool-action']} onClick={onClick} theme={isSetup ? THEME_CONSTANTS.tertiary : THEME_CONSTANTS.primary}>
    <Text textType={TextType.Caption} value={isSetup ? messages.manage : messages.setUp} />
  </Button>
);
